const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

/**
 * linkifyText
 * Splits a message into plain text and real <a> elements wherever a
 * URL appears. Never uses dangerouslySetInnerHTML - it only ever
 * builds React text nodes and anchor elements from the pieces, so
 * there's no HTML-injection surface even though the input is
 * user-supplied chat text.
 */
export default function linkifyText(text) {
  if (!text) return text;
  const parts = text.split(URL_PATTERN);

  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      // eslint-disable-next-line react/no-array-index-key
      <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="chat-link">
        {part}
      </a>
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <span key={i}>{part}</span>
    )
  );
}